import { requestTemplate } from 'api';
import { IDetails, IPendingInviteUsers, IDataRoom } from 'interfaces';
import { NewInvitesResponse } from './users';
import { AcceptParentInvitePayload, CreateInviteLinkPayload, CreateInviteLinkResponse, IRoomInite } from 'interfaces/IInvitations';

//INVITES

const getNewInvite = (payload: {
  emails: string[];
  room_id: string;
  group_id: string;
  type?: string;
  details: IDetails;
}) => requestTemplate.post<NewInvitesResponse>(`/invites/invite/?action=create&id=${payload.room_id}`, payload);
const getPendingInviteUsers = (room_id: string) =>
  requestTemplate.get<IPendingInviteUsers[]>(`/invites/?room_id=${room_id}`);
const deleteInvite = (invite_id: string) =>
  requestTemplate.delete<IPendingInviteUsers[]>(`/invites/?invite_id=${invite_id}`);
const acceptInvite = (invite_id: string) => requestTemplate.post<IDataRoom>(`/invites/accept/?invite_id=${invite_id}`);
const declineInvite = (invite_id: string) => requestTemplate.delete(`/invites/decline/?invite_id=${invite_id}`);
const getInvitesByUser = (user_id?: string) =>
  requestTemplate.get<IRoomInite[]>(`/invites/by_user/`, { params: { user_id } });
const changeInviteRole = (payload: {invite_id: string, group_id: string, role_name: string}) =>
  requestTemplate.put(`/invites/${payload.invite_id}/`, payload.role_name);
const reSendInvite = (payload: {invite_id: string, ttl_invite?: string}) =>
  requestTemplate.post<NewInvitesResponse>(`/invites/reopen/`, payload);



const createInviteLink = (payload: CreateInviteLinkPayload) =>
  requestTemplate.post<CreateInviteLinkResponse>(`/invites/parent-invite/`, payload);

const acceptParentInvite = (payload: AcceptParentInvitePayload) =>
  requestTemplate.post<string>(`/invites/invite/by-parent/`, payload);

const invites = {
  getNewInvite,
  getPendingInviteUsers,
  deleteInvite,
  acceptInvite,
  declineInvite,
  getInvitesByUser,
  changeInviteRole,
  reSendInvite,
  createInviteLink,
  acceptParentInvite,
};

export default invites;
